import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "results" }
const _hoisted_2 = { class: "filter-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "filter-content" }
const _hoisted_5 = {
  key: 0,
  class: "date-filter"
}
const _hoisted_6 = {
  key: 1,
  class: "game-filter"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 2,
  class: "draw-filter"
}
const _hoisted_9 = { class: "results-grid" }
const _hoisted_10 = {
  key: 0,
  class: "load-more"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

import { ref, computed, watch, onMounted } from 'vue'

import LotteryResultCard from '@/components/LotteryResultCard.vue'
import NextDrawsFilter from '@/components/NextDrawsFilter.vue'
import { useResultsStore } from '@/stores/results'
import { useGameStore } from '@/stores/game'
import { useRouter } from 'vue-router'
// import { useAuthStore } from '@/stores/auth'
const RESULTS_PER_PAGE = 10;

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ResultsView'
},
  __name: 'ResultsView',
  setup(__props) {



const showDatePicker = ref(false);
const gameStore = useGameStore()
const resultsStore = useResultsStore();
// const authStore = useAuthStore()
const router = useRouter()
const tabs = [
  { id: 'by-date', label: 'BY DATE' },
  { id: 'by-lottery', label: 'BY GAME' },
  { id: 'by-drawid', label: 'BY DRAW ID' }
];

const activeTab = ref('by-lottery'); // Default to BY GAME
const selectedDate = ref(new Date().toISOString().split('T')[0]);
const selectedGame = ref('');
const drawId = ref('');

const currentPage = ref(1);

const paginatedResults = computed(() => {
  const start = (currentPage.value - 1) * RESULTS_PER_PAGE;
  const end = start + RESULTS_PER_PAGE;
  return resultsStore.results.slice(0, end);
});

const hasMoreResults = computed(() => {
  return resultsStore.results.length > paginatedResults.value.length;
});

const loadMore = () => {
  if (hasMoreResults.value) {
    currentPage.value += 1;
  }
};

const handleDateFilter = (date: string) => {
  selectedDate.value = date || new Date().toISOString().split('T')[0];
};

const handleBet = async (game: any) => {
  await gameStore.fetchGameDetails(game.game_slug)
  router.push(`/lottery/${game?.game_slug}`);
}

const gamesList = computed(() => {
  // Use game store to show ALL games, not just games with results
  const allGames = gameStore.getProducts || [];
  if (!Array.isArray(allGames)) return [];
  
  // Sort games alphabetically by name
  return [...allGames].sort((a, b) => {
    const nameA = a.name?.toLowerCase() || '';
    const nameB = b.name?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });
});

watch(activeTab, (newTab, oldTab) => {
  if (oldTab === 'by-lottery' && newTab !== 'by-lottery') {
    selectedGame.value = '';
  }
});

watch(
  [activeTab, selectedDate, selectedGame, drawId],
  () => {
    currentPage.value = 1;
    const filters: any = {
      drawDate: '',
      drawId: '',
      drawType: '',
      gameSlug: ''
    };

    if (activeTab.value === 'by-date') {
      filters.drawType = 'by-date';
      filters.drawDate = selectedDate.value || '';
    } else if (activeTab.value === 'by-lottery') {
      filters.drawType = 'by-lottery';
      filters.gameSlug = selectedGame.value || '';
    } else if (activeTab.value === 'by-drawid') {
      filters.drawType = 'draw';
      filters.drawId = drawId.value || '';
    }

    resultsStore.setFilters(filters);
    resultsStore.fetchResults(1);
  }
);

onMounted(async () => {
  // await authStore.authenticate()
  // Fetch all products (games) to populate the dropdown immediately
  if (!gameStore.getProducts || gameStore.getProducts.length === 0) {
    await gameStore.fetchProducts();
  }
  // Set filters for BY GAME mode by default
  resultsStore.setFilters({ 
    drawType: 'by-lottery',
    gameSlug: selectedGame.value || ''
  });
  resultsStore.fetchResults(1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "section-title large" }, "Results", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "description" }, " Stay updated with daily Lucky Numbers draws, all week long. See upcoming draws, track results, and never miss a moment of the action. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("button", {
          key: tab.id,
          class: _normalizeClass(["tab-button", { active: activeTab.value === tab.id }]),
          onClick: ($event: any) => (activeTab.value = tab.id)
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (activeTab.value === 'by-date')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(NextDrawsFilter, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                handleDateFilter
              ],
              "show-date-picker": showDatePicker.value,
              "allow-past": true
            }, null, 8, ["modelValue", "show-date-picker"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-lottery')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedGame).value = $event)),
              class: "game-select"
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "All Games", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gamesList.value, (game) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: game.slug,
                  value: game.slug
                }, _toDisplayString(game.name), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedGame.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-drawid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawId).value = $event)),
              type: "text",
              placeholder: "Enter Draw ID",
              class: "draw-input"
            }, null, 512), [
              [_vModelText, drawId.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedResults.value, (result) => {
        return (_openBlock(), _createBlock(LotteryResultCard, {
          key: result.id,
          lottery: result,
          onBet: ($event: any) => (handleBet(result))
        }, null, 8, ["lottery", "onBet"]))
      }), 128))
    ]),
    (hasMoreResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "load-more-button",
            onClick: loadMore
          }, " Load More Results ")
        ]))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "results-info" }, [
      _createElementVNode("p", null, [
        _createTextVNode(" With Lucky Numbers draws every day, seven days per week, keeping your finger on every pulse can be overwhelming. "),
        _createElementVNode("br"),
        _createTextVNode(" We keep you up to date with all the information you need so you do not miss out on the action!"),
        _createElementVNode("br"),
        _createTextVNode(" We detail all the upcoming draws for each day, as well as informing you of the results of every draw."),
        _createElementVNode("br"),
        _createTextVNode(" Stay on top of the days events as well as all the upcoming draws of the week ahead! ")
      ])
    ], -1)),
    (_unref(resultsStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Loading..."))
      : (_unref(resultsStore).error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(resultsStore).error), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})